import { useEffect, useRef } from 'react';

export function usePrevious(value: any) {
  const ref = useRef<any>();
  useEffect(() => {
    // eslint-disable-next-line immutable/no-mutation
    ref.current = value;
  });
  return ref.current || value;
}
